<div class="wrap">
  <div class="page">
    <div class="page-main d-flex">
      <isophi-sidebar
        appHoverEffectSidebar
        [sourceApp]="sourceApp"
        [firstLevelMenuItems]="firstLevelMenuItems"
        [menuSections]="menuSections"
        [onNavigationChange]="onNavigationChange"
        [sidebarChangesTrigger$]="sidebarChangesTrigger$"
        [homeLink]="routerLinkFactory.homepage()"
        [showDemoSwitch]="showDemoSwitch"
        (switchToDemo)="switchDemoToDemoKindergarten()"
        [disabled]="(authService.loggedUser$ | async)?.requirePhonelVerification && !(authService.loggedUser$ | async)?.isPhonelVerified"
        [showMobileBurger]="false"
      ></isophi-sidebar>

      <div class="main-navbar-backdrop"></div>

      <!-- TODO check if mt-0 is necessary -->
      <div [ngClass]="{ 'mt-0': (showHeader$ | async) === false }" class="main-content">
        <ng-container *ngIf="showHeader$ | async">
          <app-info-banner *ngIf="shouldShowTopInfoBanners && isDemoKindergarten" type="demo"></app-info-banner>
          <app-info-banner
            *ngIf="shouldShowTopInfoBanners && licenseBanner"
            [type]="licenseBanner.type"
            [daysLeft]="licenseBanner.daysLeft"
            [section]="sectionKey$ | async"
          ></app-info-banner>
        </ng-container>

        <div class="lockable-area" [class.locked]="showAnyLockOverlay || showLockCheckLoadingOverlay">
          <ng-container *ngIf="showAnyLockOverlay">
            <ng-container *transloco="let t">
              <app-license-lock-modal
                [contained]="true"
                [title]="t('management/lock/title')"
                [moduleKey]="lockModuleNameKey"
                [text]="t('management/lock/text', { module: '<strong>' + t(lockModuleNameKey) + '</strong>' })"
              ></app-license-lock-modal>
            </ng-container>
          </ng-container>

          <app-header *ngIf="showHeader$ | async"></app-header>
          <div class="side-app main-container" [class.content-hidden]="showLockCheckLoadingOverlay">
            <router-outlet *ngIf="!showLockCheckLoadingOverlay"></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
